import { inject, observer } from 'mobx-react';
import React from 'react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { isDisabled } from '../utils/customPropStyles';

const Button = styled<any, any>('button', 'headerButton', 'header')`
    ${propStyles};
    ${isDisabled};
    &:disabled {
        opacity: 0.5;
    }
`;

Button.defaultProps = {
    display: 'flex',
    flex: ['1 0 0', '0 1 auto'],
    alignItems: 'center',
    justifyContent: 'center',
    paddingX: 'md',
    paddingY: 'sm',
    margin: '0 5px 0 5px',
    minHeight: '40px',
    fontSize: 'inherit',
    fontFamily: 'heading',
    fontWeight: 'medium',
    textTransform: 'uppercase',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    boxShadow: 'sm',
    textAlign: 'center',
    color: 'body',
    bgColor: 'gray100',
    cursor: 'pointer',
    outline: 'none',
    selected: {
        color: 'white',
        bgColor: 'primary',
    },
    isDisabled: {
        cursor: 'auto',
    },
};

@inject('dataStore', 'filterStore', 'accessibilityStore', 'screenSizeStore')
@observer
class HeaderButton extends React.Component {
    render() {
        const { children, ...rest } = this.props;
        return <Button {...rest}>{children}</Button>;
    }
}

export default withTheme(HeaderButton);



// WEBPACK FOOTER //
// ./src/Components/HeaderButton.tsx